import { IELTPopulatedData } from 'legacy/lut/classes/models/partner360/ELT/IELTPopulatedData'

const REPLACED_KEYS: Array<keyof Partial<IELTPopulatedData>> = [
  'BriefDescription',
  'Revenue',
  'TAM',
  'HQLocation',
  'Employees',
]

export const getInitialCompanyAtGlance = (
  initialData: string[],
  populatedData?: IELTPopulatedData
) => {
  if (populatedData) {
    return initialData.map((str) => {
      return REPLACED_KEYS.reduce((updatedStr, key) => {
        if (key === 'Revenue') {
          const revenue = isNaN(Number(populatedData[key]))
            ? 'XXX'
            : Number(populatedData[key]).toLocaleString()
          return updatedStr.replace(`{${key}}`, revenue)
        }
        return updatedStr.replace(`{${key}}`, populatedData[key] || 'XXX')
      }, str)
    })
  }

  return initialData
}
